import Api from '@/services/Api'

export default {
    getActivityConfigurations() {
        return Api().get("/activity-configurations");
    },
    updateActivityConfiguration(params) {
        return Api().put("/activity-configurations", params);
    },
    addActivityConfiguration(params) {
        return Api().post("/activity-configurations", params);
    },
    getActivityConfiguration(params) {
        return Api().get("/activity-configurations/" + params);
    },
    deleteActivityConfiguration(params) {
        return Api().delete("/activity-configurations/" + params);
    },
    getActivityConfigurationsByFather(params) {
        return Api().get("/activity-configurations-by-father/" + params);
    }
}



// WEBPACK FOOTER //
// ./src/services/ActivityConfigurationService.js